var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.siteTypes,"item-text":"keyAlias","item-value":"key","error-messages":_vm.errors !== undefined ? _vm.errors : [],"label":"نوع زبان سایت","outlined":"","return-object":_vm.return_object,"dense":_vm.dense},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }